import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-70bdbb7e")

_pushScopeId("data-v-70bdbb7e")
const _hoisted_1 = {
  key: 0,
  class: "handler"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CustomTextarea = _resolveComponent("CustomTextarea")
  const _directive_contextmenu = _resolveDirective("contextmenu")

  return (_openBlock(), _createBlock("div", {
    class: "editable-table",
    style: { width: _ctx.totalWidth + 'px' }
  }, [
    (_ctx.editable)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dragLinePosition, (pos, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "drag-line",
              key: index,
              style: {
          left: pos + 'px',
        },
              onMousedown: $event => _ctx.handleMousedownColHandler($event, index)
            }, null, 44, ["onMousedown"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode("table", {
      class: {
        'theme': _ctx.theme,
        'row-header': _ctx.theme?.rowHeader,
        'row-footer': _ctx.theme?.rowFooter,
        'col-header': _ctx.theme?.colHeader,
        'col-footer': _ctx.theme?.colFooter,
      },
      style: `--themeColor: ${_ctx.theme?.color}; --subThemeColor1: ${_ctx.subThemeColor[0]}; --subThemeColor2: ${_ctx.subThemeColor[1]}`
    }, [
      _createVNode("colgroup", null, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colSizeList, (width, index) => {
          return (_openBlock(), _createBlock("col", {
            span: "1",
            key: index,
            width: width
          }, null, 8, ["width"]))
        }), 128))
      ]),
      _createVNode("tbody", null, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tableCells, (rowCells, rowIndex) => {
          return (_openBlock(), _createBlock("tr", { key: rowIndex }, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(rowCells, (cell, colIndex) => {
              return _withDirectives((_openBlock(), _createBlock("td", {
                class: ["cell", {
              'selected': _ctx.selectedCells.includes(`${rowIndex}_${colIndex}`) && _ctx.selectedCells.length > 1,
              'active': _ctx.activedCell === `${rowIndex}_${colIndex}`,
            }],
                style: {
              borderStyle: _ctx.outline.style,
              borderColor: _ctx.outline.color,
              borderWidth: _ctx.outline.width + 'px',
              ..._ctx.getTextStyle(cell.style),
            },
                key: cell.id,
                rowspan: cell.rowspan,
                colspan: cell.colspan,
                "data-cell-index": `${rowIndex}_${colIndex}`,
                onMousedown: $event => _ctx.handleCellMousedown($event, rowIndex, colIndex),
                onMouseenter: ($event: any) => (_ctx.handleCellMouseenter(rowIndex, colIndex))
              }, [
                _createVNode(_component_CustomTextarea, {
                  class: ["cell-text", { 'active': _ctx.activedCell === `${rowIndex}_${colIndex}` }],
                  contenteditable: _ctx.activedCell === `${rowIndex}_${colIndex}` ? 'plaintext-only' : false,
                  modelValue: cell.text,
                  "onUpdate:modelValue": [
                    ($event: any) => (cell.text = $event),
                    _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleInput()))
                  ]
                }, null, 8, ["class", "contenteditable", "modelValue", "onUpdate:modelValue"])
              ], 46, ["rowspan", "colspan", "data-cell-index", "onMousedown", "onMouseenter"])), [
                [_vShow, !_ctx.hideCells.includes(`${rowIndex}_${colIndex}`)],
                [_directive_contextmenu, el => _ctx.contextmenus(el)]
              ])
            }), 128))
          ]))
        }), 128))
      ])
    ], 6)
  ], 4))
})